// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v8I2UkNBiziReuObNrkw {\n  max-width: 1200px;\n  margin: auto;\n  margin-bottom: 50px;\n}\n@media only screen and (max-width: 1200px) {\n  .v8I2UkNBiziReuObNrkw {\n    width: 1200px;\n  }\n}\n.v8I2UkNBiziReuObNrkw .d5C7IYRPr1g2gxUlt5bJ {\n  margin-top: -190px;\n  font-family: Poppins;\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 36px;\n  color: #ffffff;\n  margin-bottom: 10px;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"companySettingsContainer": "v8I2UkNBiziReuObNrkw",
	"heading": "d5C7IYRPr1g2gxUlt5bJ"
};
export default ___CSS_LOADER_EXPORT___;
